var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"company-details"},[_c('base-container',[_c('div',{staticClass:"company-details-inner"},[_c('company-details-map'),_c('company-details-content',{attrs:{"data":_vm.settingsData}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }